// extracted by mini-css-extract-plugin
export default {"aboutText":"aboutUs_aboutText__K8va0","aboutCont":"aboutUs_aboutCont__4K-Lb","linkCont":"aboutUs_linkCont__R5iXh","linkText":"aboutUs_linkText__S-NXo"};